import React, { useState } from 'react';
import '../src/style/contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',

    mobileNumber: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here
    console.log(formData);
  };


  return (<>
    <nav
      className="breadcrumb"
      style={{
        backgroundImage: "url('./airplane.avif')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "55px",
        color: "white"
      }}
    >
      <a href="/">Home</a> &gt; <span>Contact Us</span>
    </nav>
    <div className="contact-container container">
      <div className="row">
        <div className="contact-info col-4">
          <h2>Contact Info</h2>
          <p>Get in touch with Flightbooking team and we'll get back to you.</p>
          <div className="contact-details">
            <div className="address">
              <h4><i class="fa-solid fa-location-dot"></i> Address</h4>
              <p>My flight Bookings LLC   30 N Gould St STE R Sheridan WY 82801</p>
            </div>
            <div className="phone">
              <h4><i class="fa-solid fa-headset"></i> Call Us</h4>
              <p>1-877-254-8655 </p>
            </div>
            <div className="email">
              <h4><i class="fa-solid fa-envelope"></i> Email Us</h4>
              <p>info@flightbooking.com</p>
            </div>
            <div className="location">
              <h4><i class="fa-solid fa-clock"></i> Opening Timing</h4>
              <p>Mon - Sat: 09.00am to 18.00pm</p>
            </div>
          </div>
        </div>

        <div className="form-container col-8">
          <h2>Do You Have Any Questions</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="First Name *"
              value={formData.fullName}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="mobileNumber"
              placeholder="Enter Your Mobile Number *"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
            />
            <button type="submit" className="submit-btn">Submit Now</button>
          </form>
        </div>
      </div>
    </div>

    <section>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2960.897848589941!2d-87.70347732404407!3d42.088238152231376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fc52c44219fd7%3A0x41bfbdc1964f3fb!2s1616%20Sheridan%20Rd%20Unit%207f%2C%20Wilmette%2C%20IL%2060091%2C%20USA!5e0!3m2!1sen!2sin!4v1720862574789!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  </>
  );
};

export default Contact;
